module.exports = __webpack_public_path__ + "static/media/dropdown_icon.a46b8b1b.svg";